module.exports = __webpack_public_path__ + "static/media/wave1.b36e8e0f.png";